export const SET_USER_PASSWORD = 'SET_USER_PASSWORD';

export function setUserPassword(password: string) {
    return {
        type: SET_USER_PASSWORD,
        payload: password,
    };
}
